<template>
  <div class="dc-list">
    <dc-list-module v-for="(section, index) in sectionList"
                    :key="index" :title="section.title" :desc="section.desc"
                    :list="section.cases">
    </dc-list-module>
    <!-- <h3 class="dc-list__big-title" v-if="!!sectionListPast">Past Offerings</h3>
    <dc-list-module v-for="(section, index) in sectionListPast"
                    :key="index" :title="section.title" :desc="section.desc"
                    :list="section.cases">
                    v-if="!!sectionListPast"
    </dc-list-module> -->
    
  </div>
</template>

<script>
  import loading from '../../common/mixins/loading';
  import services from '../../services';
  import DcListModule from './list-module';

  export default {
    name: 'dcList',
    mixins: [
      loading
    ],
    components: {
      DcListModule
    },
    data () {
      return {
        secondaryList: [],
        primaryList: [],
        sectionList: [],
        sectionListPast: [],
      };
    },
    mounted () {
      this.showLoading();
      // this._loadProductList().finally(() => {
      //   this.closeLoading();
      // });
      Promise.all([
        this._loadProductList(),
        // this._loadProductListPast()
      ]).finally(()=>{
        this.closeLoading();
      })

    },
    methods: {
      _loadProductList () {
        return new Promise((resolve, reject) => {
          services.getProjectList() .then(response => {
            this.sectionList = [];
            if (response && Array.isArray(response.sections)) {
              this.sectionList = response.sections;
            }
            resolve();
          }, reject);
        });
      },
      _loadProductListPast () {
        return new Promise((resolve, reject) => {
          services.getProjectListPast() .then(response => {
            // console.log(response)
            this.sectionListPast = [];
            if (response && Array.isArray(response.sections)) {
              this.sectionListPast = response.sections;
            }
            resolve();
          }, reject);
        });
      },
    }
  };
</script>